import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classnames';
import ImmutablePropTypes from 'react-immutable-proptypes';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import { ChevronDown } from '@bibliocommons/base-icons';
import { Dropdown } from '@bibliocommons/base-dropdown';
import { Button } from '@bibliocommons/base-buttons';

import './ComboButton.scss';

function ComboButton({
  buttonTag,
  dataKey,
  block,
  rounded,
  disabled,
  isLoading,
  right,
  options,
  handleClick,
  renderDropdownLabel
}) {
  const ButtonTag = buttonTag || Button;
  const primaryOption = options.first();
  const secondaryOptions = options.slice(1);

  const primaryClassNames = cn('combo-button__primary-button', {
    'combo-button__primary-button--default': !buttonTag,
    'combo-button__primary-button--rounded': rounded
  });

  const secondaryClassNames = cn('combo-button__secondary-button', {
    'combo-button__secondary-button--default': !buttonTag,
    'combo-button__secondary-button--rounded': rounded
  });

  const containerClassNames = cn('cp-combo-button', {
    'combo-button--block': block
  });

  return (
    <div className={containerClassNames} data-key={dataKey}>
      <ButtonTag
        disabled={disabled || primaryOption.get('disabled')}
        className={primaryClassNames}
        isLoading={isLoading}
        handleClick={() => handleClick(primaryOption.get('value'))}
        dataKey="combo-button-primary-button"
      >
        {primaryOption.get('label')}
      </ButtonTag>
      <Dropdown
        dataKey="combo-button-dropdown"
        right={right}
        options={secondaryOptions}
        handleSelect={handleClick}
        renderTrigger={(handleToggle, expanded) => (
          <ButtonTag
            disabled={disabled}
            className={secondaryClassNames}
            handleClick={isLoading ? undefined : handleToggle}
            dataKey="combo-button-secondary-button"
            aria-expanded={expanded}
            aria-haspopup
          >
            <ScreenReaderMessage>{renderDropdownLabel()}</ScreenReaderMessage>
            <ChevronDown className="combo-button__secondary-button__chevron" />
          </ButtonTag>
        )}
      />
    </div>
  );
}

ComboButton.propTypes = {
  buttonTag: PropTypes.elementType,
  dataKey: PropTypes.string,
  block: PropTypes.bool,
  rounded: PropTypes.bool,
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  right: PropTypes.bool,
  options: ImmutablePropTypes.listOf(
    ImmutablePropTypes.mapContains({
      label: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node, PropTypes.string]),
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      disabled: PropTypes.bool
    })
  ).isRequired,
  handleClick: PropTypes.func.isRequired,
  renderDropdownLabel: PropTypes.func.isRequired
};

ComboButton.defaultProps = {
  right: true
};

export default React.memo(ComboButton);
